export const FloodOrderOptionsFormTestIds = {
  PRODUCT_SELECT: 'flood-order-options-form.product-select',
  RUSH_SWITCH: 'flood-order-options-form.rush-switch',
  COMMENTS_INPUT: 'flood-order-options-form.comments-input',
};
